import { useCallback } from "react";
import { useActiveBucket, useActiveCategory, useSelection } from "../store/selectors";
import { getPriceWithCurrency } from "../utils/formatPrice";

export function usePriceDelta() {
  const activeCategory = useActiveCategory();
  const selection = useSelection(activeCategory);
  const activeBucket = useActiveBucket(activeCategory);

  const getPriceDelta = useCallback(
    (price: number): string | undefined => {
      if (!selection) return;

      const isSingle = selection.kind === "single";

      if (isSingle) {
        const selectedItem = activeBucket.items.find(
          (item) => item.uid === selection.uid
        );
        if (!selectedItem) return;

        const delta = (selectedItem.price ?? 0) - (price ?? 0);
        if (delta === 0) return;

        const sign = delta < 0 ? "+" : "-";
        return getPriceWithCurrency(Math.abs(delta), sign);
      }

      // Multi-select
      if (price > 0) {
        return getPriceWithCurrency(Math.abs(price), "+");
      }
    },
    [selection, activeBucket]
  );

  return { getPriceDelta, activeBucket };
}